import React from 'react';

import { Button } from '@mui/material';
import { TitleWithDescription } from '@infoods/lifebase-ui';

import classes from './BannerSection.module.scss';
import { FormFieldsGrid } from '../../../FormFieldsGrid/FormFieldsGrid';
import {
  CHALLENGE_BANNER_UPLOAD_TYPE,
  ChallengeBannerUploadType,
} from '../../../../../constants/challengeBannerUploadType';

type BannerSectionProps = {
  onUploadBanner: (bannerType: ChallengeBannerUploadType) => void;
};

export const BannerSection = ({ onUploadBanner }: BannerSectionProps) => {
  return (
    <FormFieldsGrid customPadding className={classes.container}>
      <TitleWithDescription
        title="Banner"
        titleFont="body-14-bold"
        description="These will be background images, similar to a Facebook cover photo. They will be placed on your custom landing page."
      />
      <div className={classes.bannerButtons}>
        <Button
          variant="outlined"
          color="secondary"
          size="small"
          onClick={() => onUploadBanner(CHALLENGE_BANNER_UPLOAD_TYPE.WEB)}
        >
          Upload Banner for Web
        </Button>
        <Button
          variant="outlined"
          color="secondary"
          size="small"
          onClick={() => onUploadBanner(CHALLENGE_BANNER_UPLOAD_TYPE.MOBILE)}
        >
          Upload Banner for Mobile
        </Button>
      </div>
    </FormFieldsGrid>
  );
};
